import link from '~/components/atoms/a-links/a-link-v2.data'
import copy from '~/components/atoms/a-copy/a-copy.data'

export default {
  logo: [
    {
      ...link,
      copy: 'Tribal Worldwide',
      href: {
        url: '/',
        cached_url: '/',
      },
    },
  ],
  general: [
    {
      ...copy,
      heading: 'Tribal Worldwide London',
      copy:
        "<p>12 Bishop's Bridge Road\n" +
        'London W2 6AA, United Kingdom\n' +
        '+44 (0) 207 262 0011\n\n' +
        '</p>',
    },
    {
      ...link,
      copy: 'Map',
      target: '_blank',
      href: {
        url: '/',
        cached_url: '/',
      },
    },
  ],
  contacts: [
    {
      ...copy,
      heading: 'New Business',
      copy: '<p><a href="mailto:jamie.willey@tribalworldwide.co.uk">jamie.willey@tribalworldwide.co.uk</a></p>',
    },
    {
      ...copy,
      heading: 'Recruitment',
      copy: '<p><a href="mailto:recruitment@tribalworldwide.co.uk">recruitment@tribalworldwide.co.uk</a></p>',
    },
    {
      ...copy,
      heading: 'Press & Media',
      copy:
        '<p>' +
        '<a href="mailto:sarah@pumpkin.uk.com">sarah@pumpkin.uk.com</a><br/>' +
        '<a href="tel:+442072872007">+44 207 287 2007</a><br/>' +
        '</p>',
    },
  ],
  social: [
    {
      ...link,
      copy: 'Twitter',
      href: {
        url: 'https://www.linkedin.com/company/tribal-worldwide-london',
        cached_url: 'https://www.linkedin.com/company/tribal-worldwide-london',
      },
    },
    {
      ...link,
      copy: 'LinkedIn',
      href: {
        url: 'https://www.linkedin.com/company/tribal-worldwide-london',
        cached_url: 'https://www.linkedin.com/company/tribal-worldwide-london',
      },
    },
    {
      ...link,
      copy: 'Instagram',
      href: {
        url: 'https://www.linkedin.com/company/tribal-worldwide-london',
        cached_url: 'https://www.linkedin.com/company/tribal-worldwide-london',
      },
    },
  ],
  footnotes: [
    {
      ...copy,
      copy: '© Tribal Worldwide London 2020 - All Rights Reserved',
    },
    {
      ...link,
      copy: 'Gender Pay Gap',
      href: {
        url: '/',
        cached_url: '/',
      },
    },
    {
      ...link,
      copy: 'Modern Slavery Act',
      href: {
        url: '/',
        cached_url: '/',
      },
    },
    {
      ...link,
      copy: 'Cookie Policy',
      href: {
        url: '/',
        cached_url: '/',
      },
    },
  ],
}
